import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import api from '../../../services/api';
import Utils from '../../../services/utils';
import { CampaignHeaderWithLinks } from '../CampaignHeader';

import { useArrayState } from '../../../services/hooks/UseArrayState';
import Table from '../Table';

import NoCampaigns from '../../../containers/campanhas/CTA';
import { LoaderMain as Loader } from '../../Loader';

const TABLESTATES = {
	loading: 'LOADING',
	hasData: 'HASDATA',
	noData: 'NODATA',
};

const MyCampaigns = () => {
	const [tableState, setTableState] = useState(TABLESTATES.loading);
	const [punctual, addPunctual] = useArrayState([]);
	const [recurring, addRecurring] = useArrayState([]);

	useEffect(() => {
		TagManager.dataLayer({
			dataLayer: {
				event: 'PageView',
				page: 'Listagem de campanhas',
			},
			dataLayerName: 'Campanhas',
		});
	}, []);

	const CAMPAIGN_TYPES = {
		pontual: (data) => {
			addPunctual({
				id: data.id,
				date: data.date,
				value: data.value > 0 ? Utils.currencyFormatter(data.value, 1) : 'Não possui custo',
				channel: data.channel,
				status: data.status,
				href: data.id,
			});
		},
		recorrente: (data) => {
			addRecurring({
				id: data.id,
				date: data.date,
				value: data.value > 0 ? Utils.currencyFormatter(data.value, 1) : 'Não possui custo',
				channel: data.channel,
				status: data.status,
				href: data.id,
			});
		},
	};

	const filterCampaigns = (campaigns) => {
		campaigns.forEach(campaign => CAMPAIGN_TYPES[campaign.attributes.type](campaign.attributes));
	};

	useEffect(() => {
		api.get('/api/v2/demands/all')
			.then((response) => {
				if (response.data.demands.length > 0) {
					filterCampaigns(response.data.demands);
					setTableState(TABLESTATES.hasData);
				} else {
					setTableState(TABLESTATES.noData);
				}
			});
	}, []);

	const renderCampaigns = () => (
		<div style={{ padding: '30px 38px 0' }}>
			<CampaignHeaderWithLinks>Minhas campanhas</CampaignHeaderWithLinks>
			<Table
				title="Campanhas pontual"
				tableData={punctual}
				target="campaign"
				forceLoaded
			/>
			<Table
				title="Campanhas recorrente"
				marginTop="30px"
				tableData={recurring}
				target="campaign"
				forceLoaded
			/>
		</div>
	);

	const renderLoader = () => (
		<div style={{ padding: '30px 38px 0' }}>
			<Loader />
		</div>
	);

	const componentesToRender = {
		NODATA: <NoCampaigns />,
		HASDATA: renderCampaigns(),
		LOADING: renderLoader(),
	};

	return (
		<div>
			{componentesToRender[tableState]}
		</div>
	);
};

export default MyCampaigns;
